import React from 'react';
import Carousel from "react-multi-carousel";
import Container from 'react-bootstrap/Container';
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};


export default class extends React.Component {
  render() {
    return (
      <Container>
      <h5 className="center certificates-title">Wyróżnienia i certyfikaty</h5>
        <Carousel 
            arrows={false}
            className="certificates-carousel"
            swipeable={false}
            draggable={false}
            autoPlay={true}
            showDots={true}
            infinite={true}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            deviceType={this.props.deviceType}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
        >
          <img className="img-certificate-main" src="isoqar.jpg" alt="" />
          <img className="img-certificate" src="cert2.png" alt="" />
          <img className="img-certificate" src="cert3.jpg" alt="" />
          <img className="img-certificate" src="cert4.jpg" alt="" />
          <img className="img-certificate" src="cert5.jpg" alt="" />
        </Carousel>
      </Container>
    );
  }
}